import React, { useEffect, useState } from "react";
import "react-dropdown/style.css";
import Header from "./../../components/Header";
import Sidebar from "./../../components/Sidebar";
import { useLocation } from "react-router-dom";
import { RouterConfig } from "navigation/RouterConfig";
import { useSelector, useDispatch } from "react-redux";
import SnackBar from "components/SnackBar/SnackBar";
import { SnackBarStoreAction } from "Store/SnackBar";
import { useSessionTimeout } from "hooks/useSessionTimeout";
//import NlQueryFab from "components/NlQuery/NlQueryFab";
// import AgentChatFab from "components/AgentChat/AgentChatFab"; // see remarks near its render below
import CopilotChatFab from "components/AgentChat/CopilotChatFab";

const MainContainer = (props) => {
  const dispatch = useDispatch();
  const snackBar = useSelector((state) => state.snackBar);

  // Enforces 8-hour hard session expiry with full Azure AD sign-out.
  // Silent token refresh continues to work transparently within this window.
  useSessionTimeout();

  const locationObj = useLocation();
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const snackReset = () => {
    const obj = {
      open: false,
      message: "",
      severity: "",
    };
    dispatch(SnackBarStoreAction.updateSnack(obj));
  };

  useEffect(() => {
    setSnack({
      open: snackBar.open,
      message: snackBar.message,
      severity: snackBar.severity,
    });
  }, [snackBar.open]);

  return (
    <div>
      <div className={"home-section"}>
        {locationObj.pathname !== "/" &&
          !locationObj.pathname.toLowerCase().startsWith("/loadplan") &&
          !locationObj.pathname.toLowerCase().startsWith("/fac") && <Header />}
        <div className={"main-section"}>
          {locationObj.pathname !== "/" &&
            !locationObj.pathname.toLowerCase().startsWith("/obt") &&
            !locationObj.pathname.toLowerCase().startsWith("/fac") &&
            !locationObj.pathname.toLowerCase().startsWith("/rostersearch") &&
            !locationObj.pathname.toLowerCase().startsWith("/roster-config") &&
            !locationObj.pathname
              .toLowerCase()
              .startsWith("/new-roster-config") &&
            !locationObj.pathname.toLowerCase().startsWith("/bulkedit") &&
            !locationObj.pathname
              .toLowerCase()
              .startsWith("/trainee-details") &&
            !locationObj.pathname.toLowerCase().startsWith("/pii-report") &&
            !locationObj.pathname.toLowerCase().startsWith("/contact-roster") &&
            !locationObj.pathname.toLowerCase().startsWith("/obtinfo") &&
            !locationObj.pathname.toLowerCase().startsWith("/assigntrainees") &&
            !locationObj.pathname
              .toLowerCase()
              .startsWith("/createidmticket") &&
            !locationObj.pathname.toLowerCase().startsWith("/learnpoint") &&
            !locationObj.pathname.toLowerCase().startsWith("/centerpoint") &&
            !locationObj.pathname.toLowerCase().startsWith("/milestones") &&
            !locationObj.pathname
              .toLowerCase()
              .startsWith("/createmilestones") &&
            !locationObj.pathname.toLowerCase().startsWith("/loadplan") &&
            !locationObj.pathname.toLowerCase().startsWith("/welcome") &&
            !locationObj.pathname.toLowerCase().startsWith("/shipping") && (
              <Sidebar />
            )}

          <div className={"info-section"}>
            <RouterConfig />
          </div>
          {/* <NlQueryFab /> */}
          {/* AgentChatFab (ADK/Cloud Run agent launcher) temporarily commented
             out per request while evaluation focus is on the Copilot Studio
             path below -- not removed, just not rendered, so it's a one-
             line change to bring back when needed. AgentChatFab.js itself
             is untouched. */}
          {/* <AgentChatFab /> */}
          <CopilotChatFab />
          <SnackBar snack={snack} snackReset={snackReset}></SnackBar>
        </div>
      </div>
    </div>
  );
};

export default MainContainer;
